import React, { useEffect, useState } from 'react';
import CustomButton from '../../../components/customButton';
import CustomInput from '../../../components/customInput';
import ActionButtons from '../../../components/actionButtons';
import utils from '../../../utils';
import './styles.scss';

const InviteUsersBody = ({ onChangeCB }) => {
  const [email, setEmail] = useState('');
  const [users, setUsers] = useState([]);
  const [errors, setErrors] = useState({});
  const [usedEmails, setUsedEmails] = useState([]);

  useEffect(() => {
    const validation = {
      'invite-email': [
        { key: 'required', value: true },
        { key: 'email', value: true },
        { key: 'unique', value: usedEmails, customMessage: 'Email is already being used!' }
      ]
    };

    const errorList = {
      'invite-email': utils.fieldValidation(email, validation['invite-email']).join(', ')
    };
    setErrors(errorList);
  }, [email]);

  useEffect(() => {
    onChangeCB && onChangeCB(users);
  }, [users]);

  const addUser = userToAdd => {
    const usersList = [...users, userToAdd];
    setUsers(usersList);
  };

  const removeUser = email => {
    const usersList = users.filter(user => user.email.toLowerCase() !== email.toLowerCase());
    setUsers(usersList);
    setUsedEmails(usersList.map(user => user.email));
  };

  const renderUserList = () => {
    return users.map(user => {
      return (
        <div className="user-row" key={user.email}>
          <div className="user-info">
            <span className="email">{user.email}</span>
          </div>
          <div className={'action-buttons'}>
            <ActionButtons
              buttons={[
                {
                  id: `remove-user`,
                  icon: 'removeUser',
                  key: 'Remove',
                  tooltip: 'Remove User',
                  onPress: () => removeUser(user.email)
                }
              ]}
            />
          </div>
        </div>
      );
    });
  };

  return (
    <div className="new-users">
      <div className="new-users-header">
        <div className="email">
          <CustomInput
            placeholder={'Type an email to add'}
            id="invite-email"
            type="text"
            value={email}
            isEditable={true}
            autoComplete={'email'}
            onChange={e => {
              setEmail(e.target.value);
            }}
            errorMessage={errors['invite-email']}
          />
        </div>
        <div className="action-buttons">
          <CustomButton
            title="Add"
            classes="btn btn-primary"
            handleClick={() => {
              addUser({ email });
              setEmail('');
            }}
            disabled={errors['invite-email'] !== ''}
          />
        </div>
      </div>
      <div className="new-users-list">{renderUserList()}</div>
    </div>
  );
};

export default InviteUsersBody;
